import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { CLINIC } from "../data/catalog";
import { LeafGlyph } from "./Marquee";

const COLS = [
  {
    title: "Shop",
    links: [
      { label: "All Products", to: "/shop" },
      { label: "Hair Care", to: "/shop?cat=Hair%20Care" },
      { label: "Skin Care", to: "/shop?cat=Skin%20Care" },
      { label: "Body Care", to: "/shop?cat=Body%20Care" },
      { label: "Sets & Gifting", to: "/shop?cat=Sets%20%26%20Gifting" },
    ],
  },
  {
    title: "About",
    links: [
      { label: "Our Story", to: "/our-story" },
      { label: "How We Make It", to: "/how-we-make-it" },
      { label: "The Clinic", to: "/the-clinic" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Your Account",
    links: [
      { label: "Sign In", to: "/account" },
      { label: "My Orders", to: "/account?tab=orders" },
      { label: "Track Your Order", to: "/account?tab=orders" },
      { label: "Saved Addresses", to: "/account?tab=addresses" },
    ],
  },
  {
    title: "Help",
    links: [
      { label: "FAQs", to: "/faqs" },
      { label: "Shipping Policy", to: "/policies/shipping" },
      { label: "Refund & Cancellation", to: "/policies/refunds" },
      { label: "Terms of Service", to: "/policies/terms" },
      { label: "Privacy Policy", to: "/policies/privacy" },
    ],
  },
];

const Footer = () => (
  <footer className="bg-ink-deep text-cream" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 py-16 md:px-8 md:py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <img src="/assets/logo-white.png" alt="Ayushi by Dr. Shibina" className="h-14 w-auto" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/70">
            Health and beauty through real Ayurveda. Ayurvedic personal care, formulated by a
            practising physician and made in our own licensed facility in Thiruvananthapuram,
            Kerala.
          </p>
          <a
            href={CLINIC.googleUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-6 inline-flex items-center gap-2 border border-cream/15 px-4 py-2 text-xs tracking-[0.14em] text-cream/75 transition-colors hover:border-cream/40"
            data-testid="footer-google-rating"
          >
            <Star className="h-3.5 w-3.5 fill-gold text-gold" />
            {CLINIC.rating} on Google · {CLINIC.reviewCount} reviews
          </a>
        </div>

        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.3em] text-sage">{col.title}</p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-cream/70">
              {col.links.map((l) => (
                <Link key={l.label} to={l.to} className="transition-colors hover:text-cream" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s|&/g, "-")}`}>
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        ))}

        <div className="md:col-span-2">
          <p className="text-[11px] uppercase tracking-[0.3em] text-sage">Reach us</p>
          <div className="mt-5 flex flex-col gap-3 text-sm text-cream/70">
            <a href={`mailto:${CLINIC.email}`} className="break-all transition-colors hover:text-cream" data-testid="footer-email">{CLINIC.email}</a>
            <a href={`tel:${CLINIC.phoneRaw}`} className="transition-colors hover:text-cream" data-testid="footer-phone">{CLINIC.phone}</a>
            <a href={CLINIC.whatsapp} target="_blank" rel="noreferrer" className="transition-colors hover:text-cream" data-testid="footer-whatsapp">WhatsApp</a>
            <p className="text-cream/50">Mon to Sat, 10 AM to 7 PM</p>
          </div>
        </div>
      </div>

      <div className="mt-16 space-y-2 border-t border-cream/10 pt-8 text-[11px] leading-relaxed tracking-[0.06em] text-cream/40">
        <p>
          © 2026 Ayushi Ayurveda Wellness. All rights reserved. Ayushi by Dr. Shibina is a brand of
          Ayushi Ayurveda Wellness, a proprietorship of Shibina Shemim.
        </p>
        <p data-testid="footer-gstin">GSTIN 32KECPS4489R1ZE</p>
        <p data-testid="footer-address">
          Registered address: TC 5/1647, Cheruvakkal, Chavadimukku Road, Sreekaryam,
          Thiruvananthapuram, Kerala 695017
        </p>
        <p className="inline-flex items-center gap-2 pt-1">
          <LeafGlyph className="h-3 w-3 text-sage" />
          Made in our own licensed facility in Thiruvananthapuram.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
